export const BATCH_REQUEST_CHUNK_SIZE = 1000;

export const GOOGLE_SHEETS_TOAST_SUCCESS_ID = 'GOOGLE_SHEETS_TOAST_SUCCESS_ID';

export const GOOGLE_SHEETS_TOAST_ERROR_ID = 'GOOGLE_SHEETS_TOAST_ERROR_ID';

export const ITEM_MAX_IMAGE_COUNT = 5;
